(function () {
  var SECTION_SELECTOR = '.oddit-section-reviews-carousel';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-reviews-carousel__track');
    var prevBtn = section.querySelector('.oddit-section-reviews-carousel__button--prev');
    var nextBtn = section.querySelector('.oddit-section-reviews-carousel__button--next');
    var progressBar = section.querySelector('.oddit-section-reviews-carousel__progress-bar');

    if (!track) return;

    function getSlideWidth() {
      var slide = track.querySelector('.oddit-section-reviews-carousel__card');
      if (!slide) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateProgress() {
      if (!progressBar) return;
      if (track.scrollWidth <= track.clientWidth) {
        progressBar.style.setProperty('--carousel-progress', '1');
        return;
      }
      // Fraction of total carousel content currently visible or scrolled past.
      // At start: clientWidth / scrollWidth (initial visible portion).
      // At end: scrollWidth / scrollWidth = 1.
      var progress = (track.scrollLeft + track.clientWidth) / track.scrollWidth;
      progressBar.style.setProperty('--carousel-progress', String(Math.max(0, Math.min(1, progress))));
    }

    function updateButtonStates() {
      if (!prevBtn || !nextBtn) return;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 1);
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    function scrollByDirection(direction) {
      var slideWidth = getSlideWidth();
      if (!slideWidth) return;
      track.scrollBy({ left: slideWidth * direction, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByDirection(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByDirection(1);
      });
    }

    track.addEventListener('scroll', function () {
      updateProgress();
      updateButtonStates();
    }, { passive: true });

    var resizeObserver = new ResizeObserver(function () {
      updateProgress();
      updateButtonStates();
    });
    resizeObserver.observe(track);

    // Initial state
    updateProgress();
    updateButtonStates();
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector ? e.target.querySelector(SECTION_SELECTOR) : null;
    if (section) initSection(section);
  });
})();